import React, { useContext } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Button } from '../../../../components/ui/button';
import toast from 'react-hot-toast';
import { BlogContext } from '../../BlogContext';

interface BlogDiscardProps {
  onClose?: () => void;
}

const BlogDiscard = ({ onClose }: BlogDiscardProps) => {
  const { blogContent, handleUpdateBlogContent } = useContext(BlogContext);

  const handleDiscard = async () => {
    if (blogContent) {
      console.log('prevState', blogContent.prevState);
      handleUpdateBlogContent({
        ...blogContent,
        content: blogContent.prevState,
      });
      onClose?.();
      toast.success('Changes discarded successfully');
    }
  };

  return (
    <Dialog.Root>
      <Dialog.Trigger asChild>
        <Button
          variant={'customSecondary'}
          className="bg-secondary w-full text-xl"
        >
          Discard Changes
        </Button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/20" />
        <Dialog.Content className="fixed text-text-primary left-1/2 top-1/2  w-[400px]  lg:w-[28vw]  -translate-x-1/2 -translate-y-1/2 rounded-lg bg-background-main p-[25px]">
          <Dialog.Title className="text-xl font-bold text-primary">
            Discard All Changes
          </Dialog.Title>
          <Dialog.Description className="mb-5 mt-2.5 text-[15px] leading-normal text-mauve11">
            Are you sure you want to discard all changes and revert to the
            original content? This action cannot be undone.
          </Dialog.Description>
          <div className="mt-[25px] gap-4 flex justify-end">
            <Dialog.Close asChild>
              <Button variant={'customSecondary'} className="bg-secondary">
                Cancel
              </Button>
            </Dialog.Close>
            <Dialog.Close asChild>
              <Button
                variant={'customSecondary'}
                className="bg-secondary"
                onClick={handleDiscard}
              >
                Yes, Discard All
              </Button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default BlogDiscard;
